
























import {Component, Mixins} from 'vue-property-decorator';
import {CommonModelUtils, Filter, FilterRetrieveResponse} from '@/model/CommonModel';
import CheckboxInput from '@/components/input/CheckboxInput.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import TextInput from '@/components/input/TextInput.vue';
import BooleanCheckboxInput from '@/components/input/BooleanCheckboxInput.vue';
import CheckFilterMixin from '@/components/table/filter/CheckFilterMixin';
import UserApi from '@/api/UserApi';

@Component({
    components: {BooleanCheckboxInput, CheckboxInput, CommonButton, TextInput},
    mixins: [CheckFilterMixin]
})
export default class LikeCheckFilter extends Mixins<CheckFilterMixin>(CheckFilterMixin) {
    private searchText: string = '';

    get getFilters() {
        if (!this.searchText) {
            return [...this.filters];
        }
    
        return this.filters.filter((item: Filter) => {
            return CommonModelUtils.getOrDefault(item.valueLabel, '').toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1;
        }) ?? [];
    }

    public loadFilter() {
        this.loading = true;
        UserApi.retrieveUserFilters(this.menuId, this.tableHeader.columnId)
               .then((res: FilterRetrieveResponse) => {
                   this.filterType = res.data.filterType;
                   this.filters = res.data.filterList ?? [];

                   this.filteredValue = this.filters
                                            .filter((item: Filter) => item.selected === 'Y')
                                            .map((item: Filter) => item.valueCode)
                                            .join(',');
               })
               .finally(() => this.loading = false);
    }

    public onDone() {
        const params
            = this.filteredValue.split(',')
                  .filter((value: string) => this.getFilters.find((item: Filter) => item.valueCode === value))
                  .map((value: string) => {
                      return {
                          filterType: this.filterType,
                          valueCode: value,
                          valueCode2: ''
                      };
                  });
    
        this.getFilterPromise(params)
            .then((res: any) => {
                this.visible = false;
                this.$emit('refresh');
            });
    }

    private onAfterLeave() {
        this.searchText = '';
    }
}
